import { useInfiniteQuery } from 'query';
import type { ApiClientResponseError, DefaultResponseErrorDataObject } from 'common/services';
import { type ProgramTimelineContentObject, createProgramTimelineContentObject } from '../../../models';
import { getContentObjects } from '../services';
import { getProgramFeedInfiniteQueryKey } from './keys';

type P = {
  feedKey: string;
  limit: number;
  programId: string;
  programTopicId?: string;
};

export const useProgramFeedInfiniteQuery = ({ feedKey, limit, programId, programTopicId }: P) =>
  useInfiniteQuery<
    ProgramTimelineContentObject[],
    string | undefined,
    ApiClientResponseError<DefaultResponseErrorDataObject>
  >({
    async queryFn({ pageParam: cursor }) {
      const { data } = await getContentObjects({
        config: {
          params: {
            cursor,
            limit,
            /* eslint-disable @typescript-eslint/naming-convention -- Start: required by backend API */
            program_id: programId,
            program_topic_id: programTopicId,
            /* eslint-enable @typescript-eslint/naming-convention -- End: required by backend API */
          },
        },
      });

      return data.map((rawItem) => createProgramTimelineContentObject(rawItem));
    },
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => (lastPage.length < limit ? undefined : lastPage.at(-1)?.id),
    queryKey: getProgramFeedInfiniteQueryKey({ filter: { feedKey } }),
    gcTime: 0,
  });
